export default __webpack_public_path__ + "static/pexels-mateusz-dach-450035-3216534db1b07dbe8909256da2401b26.jpg";